import React from "react";
import { useTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";

function FooterTailwind() {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-900 dark:bg-slate-950 text-white transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          {/* Brand Section */}
          <div className="flex flex-col md:flex-row items-center justify-center md:justify-start gap-3 flex-shrink-0">
            <img
              src="/images/logo.png"
              alt="Kung Fu Weltmeisterschaft Logo"
              className="h-20 w-20 md:h-16 md:w-16 object-contain"
            />
            <span className="text-xl font-bold text-white">BER26</span>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-col md:flex-row items-center md:items-center gap-3 md:gap-6 flex-1 md:justify-center">
            <HashLink 
              to="/policies/#privacy-policy" 
              className="text-slate-300 dark:text-slate-400 hover:text-white dark:hover:text-slate-200 transition-colors text-sm whitespace-nowrap"
            >
              {t("footer.privacy_policy", "Datenschutzerklärung")}
            </HashLink>
            <HashLink 
              to="/policies/#impressum" 
              className="text-slate-300 dark:text-slate-400 hover:text-white dark:hover:text-slate-200 transition-colors text-sm whitespace-nowrap"
            >
              {t("footer.impressum", "Impressum")}
            </HashLink>
            <HashLink 
              to="/downloads/#downloads" 
              className="text-slate-300 dark:text-slate-400 hover:text-white dark:hover:text-slate-200 transition-colors text-sm whitespace-nowrap"
            >
              <i className="fas fa-download mr-2"></i>
              {t("downloads.title", "Downloads")}
            </HashLink>
          </nav>

          {/* Social Links */}
          <div className="flex gap-4 justify-center md:justify-end flex-shrink-0">
            <a
              href="https://www.facebook.com/share/1HDSpe3yKJ/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-10 h-10 bg-slate-800 dark:bg-slate-700 rounded-full flex items-center justify-center text-slate-300 dark:text-slate-400 hover:text-white dark:hover:text-slate-200 hover:bg-slate-700 dark:hover:bg-slate-600 transition-colors"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/18thworldchinwoochampionship?utm_source=qr&igsh=MTQ2NGp3cTJtOTg5Yg=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-10 h-10 bg-slate-800 dark:bg-slate-700 rounded-full flex items-center justify-center text-slate-300 dark:text-slate-400 hover:text-white dark:hover:text-slate-200 hover:bg-slate-700 dark:hover:bg-slate-600 transition-colors"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://youtube.com/@18thworldchinwoomatrialartscha?si=FH2tu-4yAr6f_GQL"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="w-10 h-10 bg-slate-800 dark:bg-slate-700 rounded-full flex items-center justify-center text-slate-300 dark:text-slate-400 hover:text-white dark:hover:text-slate-200 hover:bg-slate-700 dark:hover:bg-slate-600 transition-colors"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>

        {/* Credit */}
        <div className="mt-8 pt-8 border-t border-slate-800 dark:border-slate-700">
          <p className="text-center text-sm text-slate-400 dark:text-slate-500">
            {t("footer.credit", "© 2026 18. Weltmeisterschaften der Chin Woo Martial Arts. Alle Rechte vorbehalten.")}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default FooterTailwind;

